import { Tab, Tabs, Typography } from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useI18n } from "../hooks/useI18n";
import { PageLayout } from "../layout/PageLayout";
import { AllAppointments } from "./appointments/AllAppointments";
import { BookAppointment } from "./appointments/BookAppointment";

export const Appointments = ({ calendarUrl }: { calendarUrl: string }) => {
  const { t } = useI18n();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") ?? "all");

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);

    if (newValue === "book") {
      setSearchParams({ tab: "book" });
    } else {
      setSearchParams({});
    }
  };

  return (
    <PageLayout title={t("appointments.title")}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value="all" label={<Typography sx={{ fontSize: 14, fontWeight: 500 }}>Tous les rendez-vous</Typography>} />
        <Tab value="book" label={<Typography sx={{ fontSize: 14, fontWeight: 500 }}>Prendre rendez-vous</Typography>} />
      </Tabs>

      <div style={{ display: activeTab === "all" ? "block" : "none", height: "100%" }}>
        <AllAppointments calendarUrl={calendarUrl} />
      </div>

      <div style={{ display: activeTab === "book" ? "block" : "none", height: "100%" }}>
        <BookAppointment calendarUrl={calendarUrl} />
      </div>
    </PageLayout>
  );
};
